var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Videp_type_Active_-_Hover",
    "data-name": "Videp type | Active - Hover",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.271,
    height: 20,
    viewBox: "0 0 27.271 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5326",
    "data-name": "Caminho 5326",
    d: "M7.805,32h11.68a3.855,3.855,0,0,0,3.776-3.93V15.945a4.014,4.014,0,0,0-1.1-2.789A3.7,3.7,0,0,0,19.485,12H7.805a3.732,3.732,0,0,0-2.7,1.165A4.044,4.044,0,0,0,4,15.975v12.05a4.044,4.044,0,0,0,1.109,2.81A3.731,3.731,0,0,0,7.805,32ZM19.374,15a1,1,0,1,1-.961,1A.981.981,0,0,1,19.374,15Z",
    transform: "translate(-4 -12)",
    fill: "#0f7bff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5327",
    "data-name": "Caminho 5327",
    d: "M54.073,30.642V18.915a1.314,1.314,0,0,0-.637-1.125,1.341,1.341,0,0,0-1.3-.046l-3.183,1.616a1.629,1.629,0,0,0-.891,1.431v7.978a1.629,1.629,0,0,0,.891,1.446l3.183,1.621a1.341,1.341,0,0,0,1.311-.051A1.313,1.313,0,0,0,54.073,30.642Z",
    transform: "translate(-26.8 -14.778)",
    fill: "#6aabfd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoActive);
export default __webpack_public_path__ + "static/media/VideoActive.483a756f.svg";
export { ForwardRef as ReactComponent };